<template>
  <div>
    <el-dialog
      title="确认退出"
      :visible.sync="leaveDialog"
      :close-on-click-modal="false"
      class="delDia"
      width="400px"
    >
      <span
        >您正在参加考试名称—{{
          content
        }}考试，退出后考试仍会计时，确定要退出吗？</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="out()">确 定</el-button>
        <el-button @click="leaveDialog = false">取 消</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="确认交卷"
      :visible.sync="surplusDialog"
      :close-on-click-modal="false"
      class="delDia"
      width="400px"
    >
      <span
        >还有{{
          content
        }}道题未做完，您确定要交卷吗？确认交卷后将无法继续答题和修改答案！</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="surplusDialogSubmit()"
          >确认交卷</el-button
        >
        <el-button @click="surplusDialog = false">继续答题</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="确认交卷"
      :visible.sync="sureDialog"
      :close-on-click-modal="false"
      class="delDia sureDia"
      width="400px"
    >
      <span>您确定要交卷吗？确认交卷后将无法修改答案</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sureDialogSubmit()"
          >确认交卷</el-button
        >
        <el-button @click="sureDialog = false">继续答题</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="确认交卷"
      :visible.sync="testTimeDialog"
      :close-on-click-modal="false"
      class="delDia"
      width="400px"
    >
      <span>考试开始后{{ content }}分钟内不允许交卷，请到规定时间后再试！</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="testTimeDialog = false"
          >我知道了</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="考试时间"
      :visible.sync="fiveTimeDialog"
      :close-on-click-modal="false"
      class="delDia"
      width="400px"
    >
      <span
        >距离本场考试结束还有
        <span class="fiveTime">{{ content }}</span>
        分钟，请抓紧时间答题！到结束时间，系统将系统交卷！</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="fiveTimeDialog = false"
          >我知道了</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="确认交卷"
      :visible.sync="submitDialog"
      :close-on-click-modal="false"
      class="delDia"
      width="400px"
    >
      <div class="submitWrap">
        <div class="explain">
          请在输入框中输入“
          <span style="color: #ff3634">确认交卷</span> ”再点击最终确定
        </div>
        <el-input v-model="submitInput"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitDialogSubmit()"
          >最终确定</el-button
        >
        <el-button @click="submitDialog = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      leaveDialog: false,
      surplusDialog: false,
      testTimeDialog: false,
      fiveTimeDialog: false,
      sureDialog: false,
      submitDialog: false,
      content: "",
      submitInput: "",
    };
  },
  created() {},
  methods: {
    show(type = "", content = "") {
      // if (type == "leaveDialog") {
      //   this.leaveDialog = true;
      // } else if (type == "surplusDialog") {
      //   this.surplusDialog = true;
      // } else if (type == "testTimeDialog") {
      //   this.testTimeDialog = true;
      // }
      this[type] = true;
      this.content = content;
    },
    out() {
      this.$parent.go();
    },
    surplusDialogSubmit() {
      this.surplusDialog = false;
      // this.sureDialog = true;
      this.submitDialog = true;
    },
    sureDialogSubmit() {
      // this.sureDialog = false;
      this.submitDialog = true;
    },
    submitDialogSubmit() {
      if (this.submitInput == "确认交卷") {
        this.submitDialog = false;
        this.$parent.allQuestionSubmit();
      } else {
        this.$message.warning("请输入确认交卷");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.delDia {
  .fiveTime {
    color: #ff5554;
  }
  ::v-deep .el-dialog {
    display: flex;
    flex-direction: column;
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-height: calc(100% - 30px);
    max-width: calc(100% - 30px);
  }
  ::v-deep .el-dialog .el-dialog__body {
    flex: 1;
    overflow: auto;
  }
  ::v-deep .el-dialog__header {
    background: #fafcff;
    font-size: 18px;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    font-weight: 500;
    color: #4d4d4d;
    border-bottom: 1px solid #e6ecf5;
  }
  ::v-deep .el-dialog__body {
    .el-icon-warning {
      color: #e9ab24;
      font-size: 18px;
      margin-right: 12px;
    }
  }
  ::v-deep .is-disabled {
    background: #acc6eb !important;
  }
  ::v-deep .el-dialog__footer {
    text-align: center;
    .el-button {
      width: 100px;
      height: 36px;
      border-radius: 4px 4px 4px 4px;
      padding: 0;
    }
  }
  .el-button--primary {
    background: #3671bf;
    border-color: #3671bf;
  }
  .el-button--default {
    margin-left: 30px;
  }
}
.sureDia {
  ::v-deep .el-dialog__body {
    text-align: center;
  }
}
.submitWrap {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  ::v-deep .el-input {
    text-align: center;
  }
  ::v-deep .el-input__inner {
    width: 150px;
  }
  .explain {
    font-size: 14px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    margin-bottom: 20px;
    text-align: center;
  }
}
</style>
